import { useContext } from 'react';

import { QSetReviewHistoryContext } from './qset-review-history-provider';

function useQSetReviewHistory() {
  const context = useContext(QSetReviewHistoryContext);

  if (!context) {
    throw new Error('useQSetReviewHistory must be used within a QSetReviewHistoryProvider');
  }

  return context;
}

export { useQSetReviewHistory };
